import React from 'react';
import {Modal, Button, Col, Input, Form, Row, DatePicker, Select, Checkbox} from 'antd';

const FormItem = Form.Item;
const Option = Select.Option;

class CashManagement extends React.Component {
    state = {
        visible: false,
    }

    render() {
        const { getFieldDecorator } = this.props.form
        return (
            <Modal title="Cash Management"
                   visible={this.props.visible}
                   onCancel={this.props.hideAccountModal}
                   footer={[
                        <Button key="submit" type="primary" onClick={this.onSubmit}>Save</Button>,
                        <Button key="back" onClick={this.props.hideAccountModal}>Cancel</Button>,
                   ]}>
                <Form onSubmit={this.handleSubmit}>
                    <FormItem label="Date">
                        {getFieldDecorator('date', {
                            rules: [
                                {
                                    required: true, message: 'Please Select Date!',
                                }
                            ]
                        })(<DatePicker/>)}
                    </FormItem>

                    <FormItem label="Amount">
                      {getFieldDecorator('amount', {
                        rules: [
                          {
                            required: true, message: 'Please Enter amount!',
                          }
                        ]
                      })(<Input/>)}
                    </FormItem>
  
                    <FormItem>
                      {getFieldDecorator('isInterest', {
                        rules: []
                      })(<Checkbox>is Interest?</Checkbox>)}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const CashManagementModal = Form.create()(CashManagement)
export default CashManagementModal


// WEBPACK FOOTER //
// ./src/components/setup-and-settings/cashManagementModal.js